import { atom, map, deepMap, computed } from 'nanostores';
import { Play, Snapshot, Syncable } from '../types';
import { positions } from '../positions';

const defaultPositionMap = positions.reduce((acc, pos) => {
  acc[pos.id!] = pos
  return acc
}, {} as Record<string, Play>)

export const $tactic = deepMap<Syncable<Play>>(undefined)

export const $activeSnapshotIndex = atom<number>(0)
export const $tacticSnapShots = computed([$tactic], (data) => data.snapshots)
export const $namings = computed([$tactic], (data) => data.namings || Array(6).fill(null))

export const $tacticIsInit = atom<boolean>(true)
export const $activeSnapshot = computed([$tacticSnapShots, $activeSnapshotIndex], (snapshots, index) => {
  if (snapshots && snapshots.length > index) {
    return snapshots[index]
  }
  return null
})

export function updateTacticSnapshot(snapshot: Snapshot, index: number) {
  console.log('updateTacticSnapshot', snapshot, index)
  // @ts-ignore
  $tactic.setKey(`snapshots.${index}`, snapshot)
}
export function updateTactic(play: Syncable<Play>) {
  $tactic.set(play)
}

export function updateTacticNamings(namings: Play['namings']) {
  try {
    $tactic.setKey('namings', namings)
  } catch (e) {
    console.error('updateTacticNamings::error', e)
  }
}

async function loadTacticFromCache() {
  try {
    const tactic = await caches.open('tactic')
    if (tactic) {
      const response = await tactic.match('tactic')
      if (response) {
        console.log('loadTacticFromCache::cache', response)
        const data = await response.json()
        console.log('loadTacticFromCache::data', data)
        return data as Syncable<Play>
      } else {
        console.log('noresponse', 'tactic')
      }
    }
  } catch (e) {
    console.error('loadTacticFromCache::error', e)
  }
  return undefined
}

export async function loadTactic() {
  const defaultTactic = defaultPositionMap['pos66']
  console.log('defaultTactic', defaultTactic)
  const data = await loadTacticFromCache()
  console.log('loadTactic:::::data', data)
  console.log('loadTactic', data || defaultTactic)
  const isDataValid = data && Object.keys(data).length > 0
  $tactic.set( isDataValid ? data : defaultTactic)
  $tacticIsInit.set(false)
}

async function saveTacticToCache(tactic: Syncable<Play>) {
  try {
    const tacticCache = await caches.open('tactic')
    if (tacticCache) {
      const blob = new Blob([JSON.stringify(tactic)], { type: 'application/json' })
      const response = new Response(blob)
      await tacticCache.put('tactic', response)
      console.log('tactic saved to cache')
    }
  } catch (e) {
    console.error('saveTacticToCache::error', e)
  }
}

$tactic.listen(tactic => {
  // console.log('tactic::listen', tactic)
})
$tactic.subscribe((value, oldValue, key) => {
  console.log('tactic::changed', key, value)
  if ($tacticIsInit.get() === true) {
    return
  }
  void saveTacticToCache(value)
})